<template>
  <svg
    width="13"
    height="24"
    viewBox="0 0 13 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      y1="-0.5"
      x2="16.9706"
      y2="-0.5"
      transform="matrix(0.707107 0.707107 0.707107 -0.707107 1 0)"
      stroke="#D5C7BE"
    />
    <line
      x1="0.646447"
      y1="23.6464"
      x2="12.6464"
      y2="11.6464"
      stroke="#D5C7BE"
    />
  </svg>
</template>

<script>
export default {
  name: 'HomeRightArrow'
}
</script>
